import React, { useEffect, useState } from "react";
import { sidebar, supportAdminSidebar } from "../../Constants";
import { NavLink, useLocation } from "react-router-dom";
import axiosHttp from "../../Config";
import logoPreview from "../../Assets/Images/logo-preview.png";

const Sidebar = () => {
  const location = useLocation();
  const userType = localStorage.getItem("userType");
  const [reportCount, setReportCount] = useState(0);

  const fetchReportCount = () => {
    // First try without date filtering to get all reports
    axiosHttp
      .get(`user-reports?page=1&per_page=100`)
      .then((res) => {
        if (res.status === 200 && Array.isArray(res.data.data)) {
          // Get resolved reports from localStorage
          const resolvedReports = JSON.parse(localStorage.getItem('resolvedReports') || '[]');
          
          // Filter out resolved reports
          const unresolvedReports = res.data.data.filter(report => 
            !resolvedReports.includes(report.id)
          );
          
          const count = unresolvedReports.length;
          setReportCount(count);
        } else {
          setReportCount(0);
        }
      })
      .catch((error) => {
        console.error('Error fetching reports:', error);
        setReportCount(0);
      });
  };

  useEffect(() => {
    fetchReportCount();
    
    // Refresh every 5 seconds (poll for new reports)
    const interval = setInterval(fetchReportCount, 5000);
    
    // Listen for report status changes
    const handleReportStatusChange = (event) => {
      console.log('Report status changed:', event.detail);
      // Immediately refresh the count when a report is resolved or deleted
      fetchReportCount();
    };
    
    window.addEventListener('reportStatusChanged', handleReportStatusChange);
    
    return () => {
      clearInterval(interval);
      window.removeEventListener('reportStatusChanged', handleReportStatusChange);
    };
  }, []);

  // Refresh when navigating to report page
  useEffect(() => {
    if (location.pathname === '/report') {
      fetchReportCount();
    }
  }, [location.pathname]);

  // Helper to render badge
  const renderWithBadge = (item, children) => {
    if (item.name === "Report" && reportCount > 0) {
      return (
        <span style={{ position: "relative", display: "inline-block" }}>
          {children}
          <span style={{
            position: "absolute",
            top: -6,
            right: -10,
            background: "#e74c3c",
            color: "#fff",
            borderRadius: "50%",
            minWidth: 18,
            height: 18,
            fontSize: 12,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "0 5px",
            zIndex: 2,
            fontWeight: 600,
            boxShadow: "0 0 2px #fff"
          }}>{reportCount}</span>
        </span>
      );
    }
    return children;
  };

  return (
    <ul
      class="navbar-nav  sidebar  sidebar sidebar-dark  accordion"
      id="accordionSidebar"
    >
      <a
        class="sidebar-brand d-flex align-items-center justify-content-center"
        href="index.html"
      >
        <img src={logoPreview} alt="Linka logo" class="sidebar-brand-text mx-3 logo ml-3 navbar-brand" style={{ width: 150, height: "auto" }} />
      </a>
      

      {userType !== "U"
        ? sidebar.map((item) => {
            return (
              <li class="nav-item" key={item.id}>
                <NavLink className="nav-link" to={item.urlPath}>
                  {renderWithBadge(
                    item,
                    <>
                      <span
                        class="mr-2 "
                        dangerouslySetInnerHTML={{ __html: item.svgCode }}
                      />
                      <span
                        className={
                          location.pathname === `${item.urlPath}` ||
                          (location.pathname.includes(item.urlPath) &&
                            item.urlPath !== "/")
                            ? "txt-active"
                            : ""
                        }
                      >
                        {item.name}
                      </span>
                    </>
                  )}
                </NavLink>
              </li>
            );
          })
        : supportAdminSidebar.map((item) => {
            return (
              <li class="nav-item" key={item.id}>
                <NavLink className="nav-link" to={item.urlPath}>
                  {renderWithBadge(
                    item,
                    <>
                      <span
                        class="mr-2 "
                        dangerouslySetInnerHTML={{ __html: item.svgCode }}
                      />
                      <span
                        className={
                          location.pathname === `${item.urlPath}` ||
                          (location.pathname.includes(item.urlPath) &&
                            item.urlPath !== "/")
                            ? "txt-active"
                            : ""
                        }
                      >
                        {item.name}
                      </span>
                    </>
                  )}
                </NavLink>
              </li>
            );
          })}
    </ul>
  );
};

export default Sidebar;
